// extracted by mini-css-extract-plugin
export default {"topic":"trending_topic__K1wTD","trending_negative":"trending_trending_negative__xowLy","trending_positive":"trending_trending_positive__VAAEb"};